export const notAuthorized = "You are not authorized to perform this action.";

export const inputs = {
  message: {
    label: "Additional Message (Optional)",
    placeholder:
      "This message will be included in the email or text sent to the participant.",
  },
};
